<template>
    <transition name="fade">
      <div v-if="showModal" class="choose-client-modal">
        <div class="choose-client-modal-backdrop" @click="closeModal"></div>
        <div class="choose-client-modal-dialog">
          <div class="choose-client-modal-content">
            <div class="choose-client-modal-header">
              <h5 class="modal-title">Selecione o ponto a ser utilizado</h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="choose-client-modal-body">
              <div class="choose-client-text-container">
                <div class="search-container">
                    <input
                      type="text"
                      v-model="searchQuery"
                      class="form-control search-input"
                      placeholder="Buscar por nome do ponto, código, endereço ou base..."
                    />
                </div>
                <div class="options-container">
                    <div v-for="client in filteredClients" :key="client.CodigoPonto" class="option-item" @click="selectClient(client)">
                        <span class="name-info">{{ client.CodigoPonto }} - {{ client.NomePonto }} </span>
                        <div class="general-info">
                            <span><strong>Endereço: </strong></span>
                            <span>{{ client.EnderecoPonto }}</span>
                        </div>
                        <div class="general-info">
                            <span><strong>Base: </strong></span>
                            <span>{{ client.Base }}</span>
                        </div>
                    </div>
                    <div v-if="filteredClients.length === 0" class="no-results">
                        Nenhum resultado encontrado.
                    </div>
                </div>
              </div>
            </div>
            <div class="choose-client-modal-footer">
              <button class="cancel-button" @click="closeModal">
                <i class="fas fa-times"></i>   
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import {mapActions} from 'vuex';
  export default {
    props: ['showModal', 'clients'],
    data() {
      return {
        selected: null,
        searchQuery: ''
      };
    },
    computed: {
    filteredClients() {
          if (!this.searchQuery) return this.clients;

          const query = this.searchQuery.toLowerCase();
          return this.clients.filter(client =>
            client.NomePonto.toLowerCase().includes(query) ||
            client.CodigoPonto.toString().toLowerCase().includes(query) ||
            client.EnderecoPonto.toLowerCase().includes(query) ||
            client.Base.toLowerCase().includes(query)
          );
        },
    },
    methods: {
        selectClient(client){
            this.$emit('client-selected', client)
        },
        closeModal(mode = 'default') {
            this.$emit('close-choose-modal', mode)
        },
    },
    mounted(){},
  };
  </script>
  
  <style scoped lang="scss">
  .choose-client-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }
  
  .choose-client-modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
  }
  
  .choose-client-modal-dialog {
    position: relative;
    z-index: 1051;
    background: white;
    border-radius: 0.3rem;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    width: 70vw;
    height: fit-content;
    max-width: 100%;
    overflow: hidden;
  }

  .choose-client-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .choose-client-modal-header,
  .choose-client-modal-footer {
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    font-weight: bold;
    display: flex;
    gap: 10px;

    button {
      border-radius: 7px !important;
      transition: 0.3s ease-in-out;
      border: none;
      padding: 5px 10px;
    }
    .send-button {
      background-color: rgb(46, 134, 46);
      color: white;

      &:hover {
        background-color: rgb(33, 95, 33);
      }
    }

    .cancel-button {
      background-color: rgb(179, 52, 52);
      color: white;

      &:hover {
        background-color: rgb(141, 42, 42);
      }
    }
  }
  
  .choose-client-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .modal-title {
      font-weight: bold;
    }
  }
  
  .choose-client-modal-body {
    padding: 1rem;
    display: flex;
    gap: 10px;
    height: 100%;
  }

  .choose-client-text-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    textarea {
      resize: none
    }

    .choose-client-label {
      font-size: medium;
      font-weight: bold;
    }

    .options-container {
        display: flex;
        flex-direction: column;
        height: 35vh;
        overflow: auto;

        .option-item {
            display: flex;
            flex-direction: column;
            gap: 2px;
            border: 1px solid lightgray;
            padding: 10px;
            transition: ease-in-out 0.3s;
            cursor: pointer;

            &:hover {
                background-color: lightgray;
            }

            .name-info {
                font-size: small;
                font-weight: bold;
            }

            .general-info {
                display: flex;
                gap: 3px;
            }
        }
    }
  }

  .choose-client-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;
    min-width: 0;

    &__header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    .preview-slot {
      background-image: url('/images/background-wpp.png');
      background-color: #263b47;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
      width: 100%;
      border-radius: 10px;
      overflow-y: auto;

      .message-item {
        background-color: #037963;
        color: white;
        border-radius: 10px;
        margin: 10px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .message-body {
          font-size: 12px;
          font-weight: 500;

          .body-preview-text {
              white-space: pre-line;
              word-wrap: break-word;
              overflow-wrap: break-word;
              word-break: break-word;
              width: 100%;
          }
        }
      }
    }
  }
  
  .choose-client-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  
  .close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores ao Vue 2.1.8 */ {
    opacity: 0;
  }

  .search-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 10px;

    .search-input {
      padding: 8px;
      border: 1px solid lightgray;
      border-radius: 5px;
      outline: none;
      transition: border 0.3s ease;

      &:focus {
        border-color: #007bff;
      }
    }
  }

  .no-results {
    text-align: center;
    color: gray;
    font-style: italic;
    margin-top: 10px;
  }
</style>